import ApiBase from './base/ApiBase'
import { Incident } from '../models/dtos'

class IncidentClient extends ApiBase {
    private controllerName: string = 'Incident';

    // async Create(dto: CreateIncident, signal?: AbortSignal): Promise<string> {
    //     return this.PostAsync(`${this.controllerName}`, dto, signal);
    // }

    // async Delete(id: string, signal?: AbortSignal): Promise<void> {
    //     return this.DeleteAsync(`${this.controllerName}/${id}`, signal);
    // }

    // async GetAll(signal?: AbortSignal): Promise<Incident[]> {
    //     return this.GetAsync(`${this.controllerName}`, signal);
    // }

    // async GetSingle(id: string, signal?: AbortSignal): Promise<Incident> {
    //     return this.GetAsync(`${this.controllerName}/${id}`, signal);
    // }

    async Update(dto: Incident, signal?: AbortSignal): Promise<void> {
        return this.PutAsync(`${this.controllerName}/${dto.Id}`, dto, signal);
    }

}



export enum IncidentErrors {
    Create = 'Error creating Incident',
    Delete = 'Error deleting Incident',
    GetAll = 'Error loading Incident',
    GetSingle = 'Error loading Incident',
    Update = 'Error saving Incident',

}

export default IncidentClient;